import React, { useState } from 'react'
import styled from 'styled-components'
import { MqDesktop, MqTablet, Regular } from 'streamr-ui/css/consts'
import PrestyledOffice from './Office'
import Map from './Map'
import SectionID from '~shared/SectionID'
import { Link, LinkLook } from 'streamr-ui'

const Inner = styled.div`
    ::after {
        clear: both;
        content: '';
        display: block;
    }
`

const MapWrapper = styled.div`
    display: none;
    height: 100%;
    position: absolute;
    width: 50%;

    @media ${MqDesktop} {
        display: block;
    }
`

const Addresses = styled.div`
    box-sizing: border-box;
    padding: 6rem 0;

    @media ${MqTablet} {
        padding: 6.5rem 0;
    }

    @media ${MqDesktop} {
        float: right;
        padding: 7rem 0;
        padding-left: 12rem;
        width: 50%;
    }
`

const AddressInner = styled.div`
    margin: 0 auto;
    max-width: calc(2 * 15rem + 3rem);
    padding: 0 2rem;

    @media ${MqDesktop} {
        max-width: none;
    }
`

const Title = styled.div`
    font-size: 1.75rem;
    font-weight: ${Regular};
    line-height: 1em;
    margin-bottom: 4.5rem;

    @media ${MqTablet} {
        font-size: 2rem;
    }

    @media ${MqDesktop} {
        font-size: 2.5rem;
    }
`

const OfficesInner = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 15rem);
    justify-content: space-between;
    margin-top: -3rem;

    @media ${MqTablet} {
        margin-top: 0;
    }

    @media ${MqDesktop} {
        display: block;
        justify-content: unset;
    }
`

const Office = styled(PrestyledOffice)`
    margin-top: 3rem;

    @media ${MqTablet} {
        margin-top: 0;
    }

    @media ${MqDesktop} {
        & + & {
            margin-top: 3.5rem;
        }
    }
`

const hq = {
    id: 'hq',
    name: 'Streamr Network AG',
    city: 'Zug',
    street: 'Bahnhofstrasse 21',
    country: 'Switzerland',
    zipcode: '6300',
    mapUrl: 'https://www.google.com/maps/place/Bahnhofstrasse+21,+6300+Zug,+Switzerland/@47.1697619,8.5149968,17z',
    coords: {
        lat: 47.1697619,
        lng: 8.5149968,
    },
}

const labs = {
    id: 'labs',
    name: 'Streamr Labs',
    city: 'Helsinki',
    street: 'Siltasaarenkatu 6-10',
    country: 'Finland',
    zipcode: '00530',
    mapUrl: 'https://www.google.com/maps/place/Siltasaarenkatu+6-10,+00530+Helsinki,+Finland/@60.177837,24.9474962,17z',
    coords: {
        lat: 60.177837,
        lng: 24.9474962,
    },
}

const UnstyledOffices = ({ className }) => {
    const [selectedAddressId, setSelectedAddressId] = useState(hq.id)

    return (
        <div className={className}>
            <SectionID
                scope="about"
                value="offices"
                style={{
                    top: 0,
                }}
            />
            <Inner>
                <MapWrapper>
                    <Map center={selectedAddressId === hq.id ? hq.coords : labs.coords} />
                </MapWrapper>
                <Addresses>
                    <AddressInner>
                        <Title $appear>
                            <Link href="#offices" look={[LinkLook.Inherit]}>
                                Visit Us
                            </Link>
                        </Title>
                        <OfficesInner>
                            <Office
                                $appear
                                address={hq}
                                current={selectedAddressId === hq.id}
                                onClick={setSelectedAddressId}
                            />
                            <Office
                                $appear
                                address={labs}
                                current={selectedAddressId === labs.id}
                                onClick={setSelectedAddressId}
                            />
                        </OfficesInner>
                    </AddressInner>
                </Addresses>
            </Inner>
        </div>
    )
}

const Offices = styled(UnstyledOffices)`
    background-color: #13013d;
    color: white;
    font-size: 1rem;
    position: relative;
`

export default Offices
